import { SectionWrapper, SectionsWrapper } from "./style";
import { P, H5, H3, Row, Column } from "../../styleguide-remapped/styleguide-remapped";
import { uid } from 'react-uid';
import { ArrowRightIcon } from "../related-articles-2-columns/style";
import arrowRightSvg from "../../../assets/logos/arrow-right.svg";
import Breadcrumbs from "../../custom/breadcrumbs";
import Link from 'next/link';

const Sections = ({ block, documentData, pageType, relatedCategories, relatedTopics }) => {
  const sections = Object.keys(block).filter(key => !isNaN(key)).map(key => block[key]);
  const totalArticles = sections.reduce((sum, sc) => sum + (sc.articles?.data?.length || 0), 0);

  let leftSections = [];
  let rightSections = [];
  let leftCounter = 0;
  let rightCounter = 0;

  if (pageType === 'TOPIC' || totalArticles === 1 || sections.length === 0) {
    if (pageType === 'TOPIC' && sections.length > 0) {
      return (
        <SectionsWrapper>
          <Row>
            <Column all={12} xs={12} s={12} m={12} px={0} mx={0}>
              {sections.map(sc => section(sc, documentData, relatedCategories, relatedTopics))}
            </Column>
          </Row>
        </SectionsWrapper>
      );
    }

    const singleSection = sections.find(sc => sc.articles?.data && sc.articles.data.length > 0)
      || sections[0]
      || (documentData.attributes.articles?.[0]?.articles?.data ? {
        id: documentData.attributes.articles[0].id,
        title: documentData.attributes.articles[0].title,
        articles: documentData.attributes.articles[0].articles
      } : null);

    if (singleSection) {
      return (
        <SectionsWrapper>
          <Row>
            <Column all={12} xs={12} s={12} m={12} px={0} mx={0}>
              {section(singleSection, documentData, relatedCategories, relatedTopics)}
            </Column>
          </Row>
        </SectionsWrapper>
      );
    }
  }

  const leftSectionData = [];
  const rightSectionData = [];

  sections.forEach((sc) => {
    if (rightCounter >= leftCounter) {
      leftSectionData.push(sc);
      leftCounter += sc.articles?.data?.length || 0;
    } else {
      rightSectionData.push(sc);
      rightCounter += sc.articles?.data?.length || 0;
    }
  });

  const leftFirstHasTitle = leftSectionData[0]?.title && leftSectionData[0].title.trim().length > 0;
  const rightFirstHasTitle = rightSectionData[0]?.title && rightSectionData[0].title.trim().length > 0;
  const needsSpacer = (leftFirstHasTitle && !rightFirstHasTitle) || (!leftFirstHasTitle && rightFirstHasTitle);

  leftSections = leftSectionData.map((sc, index) =>
    section(sc, documentData, relatedCategories, relatedTopics, index === 0 && needsSpacer && !leftFirstHasTitle)
  );
  rightSections = rightSectionData.map((sc, index) =>
    section(sc, documentData, relatedCategories, relatedTopics, index === 0 && needsSpacer && !rightFirstHasTitle)
  );

  return (
    <SectionsWrapper>
      <Row>
        <Column all={12} xs={12} s={12} m={6} px={0} mx={0}>
          {leftSections}
        </Column>
        <Column all={12} xs={12} s={12} m={6} px={0} mx={0}>
          {rightSections}
        </Column>
      </Row>
    </SectionsWrapper>
  );
};

const section = (sc, topic, relatedCategories, relatedTopics, showSpacer = false) => {
  const hasTitle = sc.title && sc.title.trim().length > 0;

  return (
    <SectionWrapper id={sc.id}>
      {hasTitle ? <H3 as="h2"> {sc.title} </H3> : (showSpacer ? <div className="title-spacer" /> : null)}
      <div role={sc.articles?.data?.length > 0 ? 'list' : undefined} className="article-list">
      {sc.articles?.data?.map((article) => {
        const categoriesForArticle = [];
        const topicsForArticle = [topic];

        relatedTopics.forEach((relatedTopic) => {
          relatedTopic?.attributes?.articles?.forEach((topicSection) => {
            if (topicSection.articles?.data?.find(d => d.id === article.id) &&
              !topicsForArticle.find(d => d.id === relatedTopic.id)) {
              topicsForArticle.push(relatedTopic);
            }
          });
        });

        topicsForArticle.forEach((topicForArticle) => {
          if (topicForArticle?.attributes?.category?.data?.id && !categoriesForArticle.find(d => d.id === topicForArticle.attributes.category.data.id)) {
            categoriesForArticle.push(topicForArticle.attributes.category.data);
          }
        });

        // categoriesForArticle can be empty when a topic has no category
        // relation set in the CMS — fall back to the flat /artikel route.
        const categorySlug = categoriesForArticle[0]?.attributes?.slug;
        const topicSlug = topicsForArticle[0]?.attributes?.slug;
        const articleHref = categorySlug && topicSlug
          ? `/${categorySlug}/${topicSlug}/${article.attributes.slug}`
          : `/artikel/${article.attributes.slug}`;

        return (
          <div role="listitem" key={uid(article)}>
            <article className="container">
              <Link href={articleHref}>
                <Row className="article-header">
                <H5 as={hasTitle ? 'h3' : 'h2'} className="tile-title">{article.attributes.title}</H5>
                  <ArrowRightIcon src={arrowRightSvg} />
                </Row>
                <P className="description">{article.attributes.description}</P>
              </Link>
              <Breadcrumbs categories={relatedCategories} topics={[...topicsForArticle]} articles={[article]} breadcrumbKey={`${uid(article)}-b`} />
            </article>
          </div>
        )
      })}
      </div>
    </SectionWrapper>
  );
}

export default Sections;
